import * as R from 'ramda';
export const defaultFalsyTo = R.curry((defaultVal, val) => R.unless(R.identity, R.always(defaultVal))(val));
